import { render, staticRenderFns } from "./reviewTimeSet.vue?vue&type=template&id=533d1ac8&scoped=true&"
import script from "./reviewTimeSet.vue?vue&type=script&lang=js&"
export * from "./reviewTimeSet.vue?vue&type=script&lang=js&"
import style0 from "./reviewTimeSet.vue?vue&type=style&index=0&id=533d1ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d1ac8",
  null
  
)

export default component.exports